export default __webpack_public_path__ + "static/media/map-banner.27e847d8.jpg";